//COMMIT
export const SET_PENDING_SETTLEMENTS_RESPONSE =
  'settlementLock/SET_PENDING_SETTLEMENTS_RESPONSE'
export const SET_PAGINATION = 'settlementLock/SET_PAGINATION'
export const SET_LOADING = 'settlementLock/SET_LOADING'
export const SET_SELECTED_PRODUCT = 'settlementLock/SET_SELECTED_PRODUCT'
export const SET_SELECTED_SETTLEMENTS =
  'settlementLock/SET_SELECTED_SETTLEMENTS'

//ACTIONS
export const UPDATE_PAGINATION = 'settlementLock/UPDATE_PAGINATION'

export const GET_PENDING_SETTLEMENTS = 'settlementLock/GET_PENDING_SETTLEMENTS'
export const GET_PENDING_ETR_SETTLEMENTS =
  'settlementLock/GET_PENDING_ETR_SETTLEMENTS'
export const GET_PENDING_ETP_SETTLEMENTS =
  'settlementLock/GET_PENDING_ETP_SETTLEMENTS'

export const APPROVE_ETR_SETTLEMENT = 'settlementLock/APPROVE_ETR_SETTLEMENT'
export const BULK_APPROVE_ETR_SETTLEMENT =
  'settlementLock/BULK_APPROVE_ETR_SETTLEMENT'
export const REJECT_ETR_SETTLEMENT = 'settlementLock/REJECT_ETR_SETTLEMENT'
export const BULK_REJECT_ETR_SETTLEMENT =
  'settlementLock/BULK_REJECT_ETR_SETTLEMENT'

export const ACCEPT_ETP_SETTLEMENTS = 'settlementLock/ACCEPT_ETP_SETTLEMENTS'
export const CANCEL_ETP_SETTLEMENTS = 'settlementLock/CANCEL_ETP_SETTLEMENTS'
